declare namespace $ {

	export class $shm_hitalama_hovered extends $mol_plugin {
		pointerenter( next?: any ): any
		pointerleave( next?: any ): any
		hovered( next?: boolean ): boolean
		event( ): ({ 
			pointerenter( next?: ReturnType< $shm_hitalama_hovered['pointerenter'] > ): ReturnType< $shm_hitalama_hovered['pointerenter'] >,
			pointerleave( next?: ReturnType< $shm_hitalama_hovered['pointerleave'] > ): ReturnType< $shm_hitalama_hovered['pointerleave'] >,
		})  & ReturnType< $mol_plugin['event'] >
	}
	
}

//# sourceMappingURL=hovered.view.tree.d.ts.map